module.exports = "<button class=\"btn btn-secondary mt-1\" *ngIf=\"dataLoading\" [ladda]=\"true\">\n    Загрузка\n</button>"